export const MAIN_POOL_ID = 0
export const MAIN_LAUNCHPOOL_ADDRESS = '0xdbf1b10fe3e05397cd454163f6f1ed0c1181c3b3'
export const BOOSTING_MIGRATOR_ADDRESSES = '0x8E901C77c663642a77Df5Dad5135506D54bCf254'
